var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataBackend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0572 18.4575L17.8798 19.5917V21L13 18.9773V18.0227L17.8798 16V17.3989L15.0572 18.4575Z",
    fill: "url(#paint0_linear_5624_68268)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9429 18.5331L19.1202 17.3989V16L24 18.0227V18.9773L19.1202 21V19.5917L21.9429 18.5331Z",
    fill: "url(#paint1_linear_5624_68268)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2306 3.65471C23.8412 3.47178 23.4286 3.43343 23.0401 3.58203C22.6515 3.73064 22.3481 4.00533 22.1634 4.38447L21.1317 6.53217C20.6131 6.40049 20.0825 6.32391 19.5234 6.2814C18.9642 6.2389 18.4429 6.21645 17.893 6.22809L17.0345 3.79548C16.8836 3.37811 16.6138 3.10311 16.2578 2.91445C15.8684 2.73152 15.486 2.71455 15.0717 2.86756L12.0277 3.96842C11.6391 4.11702 11.3567 4.35895 11.148 4.75281C10.965 5.14226 10.9223 5.52901 11.0753 5.94337L11.8684 8.16425C11.3945 8.46541 10.9614 8.78878 10.5539 9.15289C10.1434 9.49896 9.75235 9.89741 9.40082 10.2785L7.02063 9.17507C6.63117 8.99214 6.24442 8.94939 5.85585 9.09799C5.46727 9.2466 5.16392 9.52129 4.98098 9.91074L3.61042 12.8089C3.42749 13.1983 3.38913 13.6109 3.53773 13.9994C3.69118 14.4164 3.96103 14.6914 4.35049 14.8743L6.49819 15.906C6.36651 16.4247 6.28992 16.9552 6.24742 17.5144C6.20491 18.0735 6.18247 18.5948 6.19411 19.1447L3.76407 20.0028C1.70777 20.7652 3.42919 23.605 3.93701 25.0096C4.08561 25.3982 4.32754 25.6806 4.71367 25.8906C5.10312 26.0736 5.48987 26.1163 5.90423 25.9633L8.12511 25.1702C8.42627 25.6441 8.74964 26.0772 9.11376 26.4847C9.45982 26.8952 9.85827 27.2863 10.2438 27.6636L9.13593 30.018C8.953 30.4074 8.91025 30.7942 9.05885 31.1828C9.20745 31.5713 9.47957 31.8751 9.86129 32.0594L12.7861 33.4466C13.1756 33.6295 13.5837 33.6421 13.9723 33.4935C14.3609 33.3449 14.6691 33.0986 14.8791 32.7124L15.909 30.5385C16.4277 30.6702 16.9582 30.7468 17.5173 30.7893C18.0765 30.8318 18.5952 30.8547 19.1477 30.8426L20.0062 33.2752C20.1597 33.6921 20.4295 33.9671 20.7829 34.1562C21.1723 34.3392 21.5547 34.3561 21.969 34.2031L25.013 33.1023C25.4016 32.9537 25.684 32.7117 25.8941 32.3256C26.077 31.9362 26.1197 31.5494 25.9667 31.1351L25.1736 28.9142C25.6476 28.613 26.0806 28.2897 26.4881 27.9255C26.8987 27.5795 27.2936 27.1883 27.667 26.7955L30.0214 27.9034C30.4109 28.0863 30.7976 28.129 31.212 27.976C31.6289 27.8226 31.9039 27.5527 32.0886 27.1736L33.4754 24.2462C33.6583 23.8567 33.6709 23.4486 33.5223 23.06C33.3737 22.6714 33.1273 22.3632 32.7335 22.1545L30.5618 21.1535C30.6935 20.6348 30.7701 20.1043 30.8126 19.5451C30.8551 18.9859 30.8775 18.4646 30.8659 17.9147L33.2985 17.0562C33.7155 16.9028 33.9905 16.6329 34.1782 16.2718C34.3612 15.8824 34.3781 15.5 34.2251 15.0857L33.1243 12.0417C32.9757 11.6531 32.7337 11.3707 32.3476 11.1606C31.9582 10.9777 31.5714 10.935 31.157 11.088L28.9362 11.8811C28.6398 11.4355 28.3165 11.0025 27.9475 10.5666C27.5971 10.1302 27.203 9.76501 26.8219 9.41348L27.9253 7.03329C28.1083 6.64383 28.151 6.25708 28.0024 5.86851C27.8538 5.47994 27.5791 5.17658 27.2 4.99189L24.298 3.61403L24.2306 3.65471ZM16.8824 8.81002C22.2504 7.89345 27.3484 11.5021 28.2654 16.8728C29.1819 22.2408 25.5733 27.3388 20.2026 28.2558C14.832 29.1728 9.73619 25.5611 8.81918 20.1904C7.90261 14.8224 11.5143 9.72659 16.8824 8.81002Z",
    fill: "url(#paint2_linear_5624_68268)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5624_68268",
    x1: 13.7273,
    y1: 21.5376,
    x2: 22.0269,
    y2: 14.6488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5624_68268",
    x1: 13.7273,
    y1: 21.5376,
    x2: 22.0269,
    y2: 14.6488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5624_68268",
    x1: 8.0802,
    y1: 40.1076,
    x2: 41.1345,
    y2: 20.7328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataBackend);
export default __webpack_public_path__ + "static/media/data-backend.f045b9c08c71ef8fd26fc4287cf3c759.svg";
export { ForwardRef as ReactComponent };